<template>
  <div>
    <div class="box">
      <el-page-header
        @back="$router.go(-1)"
        :content="content"
      ></el-page-header>
    </div>
    <el-card class="content mt20 bbb">
      <el-form
        label-position="left"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('chapterList.number')" prop="number">
          <el-input type="number" v-model="ruleForm.number"></el-input>
        </el-form-item>
        <el-form-item :label="$t('chapterList.title')" prop="title">
          <el-input v-model="ruleForm.title"></el-input>
        </el-form-item>
         <el-form-item :label="$t('serialList.active')" prop="active">
           <el-radio-group v-model="ruleForm.active">
                <el-radio :label="0">{{$t('chapterList.active0')}}</el-radio>
                <el-radio :label="1">{{$t('chapterList.active1')}}</el-radio>
            </el-radio-group>
        </el-form-item>
        <!-- <el-form-item :label="$t('chapterList.is_free')" prop="is_free">
           <el-radio-group v-model="ruleForm.is_free">
                <el-radio :label="0">{{$t('chapterList.is_free0')}}</el-radio>
                <el-radio :label="1">{{$t('chapterList.is_free1')}}</el-radio>
            </el-radio-group>
        </el-form-item> -->
        <el-form-item v-if="ruleForm.active===1" :label="$t('chapterList.show_time')" prop="show_time">
          <el-date-picker
            v-model="ruleForm.show_time"
            type="datetime"
            :picker-options="TimePickerOptions"
            :placeholder="$t('select_date')">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('chapterList.content')" prop="content">
          <div v-if="load">
                <SummerNote :id="'summernote' + new Date().getTime()" v-model="ruleForm.content" />
            </div>
        </el-form-item>
      </el-form>
      <el-button class="btn" type="primary" @click="submitForm('ruleForm')">{{
        $t("btnTip.submit")
      }}</el-button>
    </el-card>
  </div>
</template>
<script>
import time from '@/utils/timeFormat'
import SummerNote from '@/components/summernote';
import { chapterDetail, addChapter, editChapter } from "@/api/api";
export default {
  name: "editChapter",
  data() {
    return {
      time,
       TimePickerOptions: {
          disabledDate(time) {
              return (
                  time.getTime() <
                  new Date(
                      new Date().toLocaleDateString()
                  ).getTime()
              );
          },
      },
      ruleForm: {
          number:"",
        title:"",
        active:"",
        content:"",
        book:this.$route.query.book_id,
        show_time:null,
        // is_free:0
      },
      rules: {
        title: [
          {
            required: true,
            message: this.$t("chapterList").title,
            trigger: "blur",
          },
        ],
        number: [
          {
            required: true,
            message: '숫자만 입력해 주세요.',
            trigger: "blur",
          },
        ],
        content: [
          {
            required: true,
            message: this.$t("chapterList").content,
            trigger: "blur",
          },
        ],
        active: [
          {
            required: true,
            message: this.$t("chapterList").active,
            trigger: "blur",
          },
        ],
        show_time: [
          {
            required: true,
            message: this.$t("chapterList").show_time,
            trigger: "blur",
          },
        ],
        // is_free: [
        //   {
        //     required: true,
        //     message: this.$t("chapterList").is_free,
        //     trigger: "blur",
        //   },
        // ],
      },
      load:false
    };
  },
  watch:{
    'ruleForm.active':{
      handler(val){
          this.rules.show_time[0].required = (val===1?true:false)
      }
    }
  },
  components: {
      SummerNote,
  },
  computed: {
    id() {
      return Number.isNaN(Number(this.$route.query.id))
        ? undefined
        : Number(this.$route.query.id);
    },
    content() {
      return this.id === undefined
        ? this.$t("btnTip").add
        : this.$t("btnTip").edit;
    },
  },
  methods: {
    async submitForm(formName) {
      await this.$refs[formName].validate();
      let ruleForm = {...this.ruleForm}
      if(ruleForm.active===1){
        ruleForm.show_time = time.minutesTime(ruleForm.show_time)
      }else{
        delete ruleForm.show_time
      }
      if (this.id === undefined) {
        await addChapter(ruleForm);
      } else {
        delete ruleForm.create_time;
        delete ruleForm.update_time;
        await editChapter(ruleForm);
      }
      this.$router.go(-1);
    },
    async get_info() {
      const information = await chapterDetail(this.id);
      this.ruleForm = { ...information };
      this.load = true
    },
  },
  async created() {
    if (this.id === undefined) {
        this.load = true
        return
    }
    this.get_info();
  },
};
</script>
<style land="scss" scoped>
.el-date-editor {
  margin-right: 10px;
}
.bbb {
  position: relative;
  padding-bottom: 50px;
}
.bbb .btn {
  position: absolute;
  bottom: 10px;
  right: 20px;
}
</style>
